<!-- 人员状态统计 — KPI 卡片 -->
<template>
  <div class="stats-cards" v-loading="loading">
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="stats-card">
          <div class="card-header">
            <div class="card-icon doc"><i class="el-icon-user"></i></div>
            <div class="card-title">参与人员数</div>
          </div>
          <div class="card-content">
            <div class="card-value">{{ statsData.participantCount || 0 }}</div>
            <div class="card-trend" :class="getTrendClass(statsData.participantCountRate)">
              <i :class="getTrendIcon(statsData.participantCountRate)"></i>
              <span>{{ formatRate(statsData.participantCountRate) }}</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="stats-card">
          <div class="card-header">
            <div class="card-icon warning"><i class="el-icon-loading"></i></div>
            <div class="card-title">执行中人员</div>
          </div>
          <div class="card-content">
            <div class="card-value">{{ statsData.executingPersonCount || 0 }}</div>
            <div class="card-trend" :class="getTrendClass(statsData.executingPersonCountRate)">
              <i :class="getTrendIcon(statsData.executingPersonCountRate)"></i>
              <span>{{ formatRate(statsData.executingPersonCountRate) }}</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="stats-card">
          <div class="card-header">
            <div class="card-icon info"><i class="el-icon-time"></i></div>
            <div class="card-title">待执行人员</div>
          </div>
          <div class="card-content">
            <div class="card-value">{{ statsData.pendingPersonCount || 0 }}</div>
            <div class="card-trend" :class="getTrendClass(statsData.pendingPersonCountRate)">
              <i :class="getTrendIcon(statsData.pendingPersonCountRate)"></i>
              <span>{{ formatRate(statsData.pendingPersonCountRate) }}</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="8">
        <div class="stats-card">
          <div class="card-header">
            <div class="card-icon success"><i class="el-icon-check"></i></div>
            <div class="card-title">完成主单数</div>
          </div>
          <div class="card-content">
            <div class="card-value">{{ statsData.completedMainOrderCount || 0 }}</div>
            <div class="card-trend" :class="getTrendClass(statsData.completedMainOrderCountRate)">
              <i :class="getTrendIcon(statsData.completedMainOrderCountRate)"></i>
              <span>{{ formatRate(statsData.completedMainOrderCountRate) }}</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="stats-card">
          <div class="card-header">
            <div class="card-icon danger"><i class="el-icon-warning"></i></div>
            <div class="card-title">超时关联人员</div>
          </div>
          <div class="card-content">
            <div class="card-value">{{ statsData.timeoutRelatedPersonCount || 0 }}</div>
            <div class="card-trend" :class="getTrendClass(statsData.timeoutRelatedPersonCountRate)">
              <i :class="getTrendIcon(statsData.timeoutRelatedPersonCountRate)"></i>
              <span>{{ formatRate(statsData.timeoutRelatedPersonCountRate) }}</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="stats-card">
          <div class="card-header">
            <div class="card-icon primary"><i class="el-icon-star-on"></i></div>
            <div class="card-title">人均完成主单</div>
          </div>
          <div class="card-content">
            <div class="card-value">{{ formatDecimal(statsData.avgCompletedMainPerPerson) }}</div>
            <div class="card-trend" :class="getTrendClass(statsData.avgCompletedMainPerPersonRate)">
              <i :class="getTrendIcon(statsData.avgCompletedMainPerPersonRate)"></i>
              <span>{{ formatDiff(statsData.avgCompletedMainPerPersonRate) }}</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'PersonnelStatsCards',
  props: {
    statsData: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false }
  },
  methods: {
    getTrendClass(rate) {
      if (rate === undefined || rate === null || rate === '') return '';
      return Number(rate) > 0 ? 'trend-up' : Number(rate) < 0 ? 'trend-down' : '';
    },
    getTrendIcon(rate) {
      if (rate === undefined || rate === null || rate === '') return '';
      return Number(rate) > 0 ? 'el-icon-top' : Number(rate) < 0 ? 'el-icon-bottom' : '';
    },
    formatRate(rate) {
      if (rate === undefined || rate === null || rate === '') return '—';
      const n = Number(rate);
      const sign = n > 0 ? '+' : '';
      return `环比 ${sign}${n}%`;
    },
    formatDiff(rate) {
      if (rate === undefined || rate === null || rate === '') return '—';
      const n = Number(rate);
      const sign = n > 0 ? '+' : '';
      return `环比 ${sign}${n}`;
    },
    formatDecimal(v) {
      if (v === undefined || v === null || v === '') return '0';
      return Number(v).toFixed(2);
    }
  }
};
</script>

<style lang="scss" scoped>
.stats-cards {
  margin-bottom: 20px;
  .stats-card {
    background: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    min-height: 110px;
    &:hover {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
      transform: translateY(-2px);
    }
    .card-header {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .card-icon {
        width: 40px;
        height: 40px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        background-color: #f0f9ff;
        color: #409eff;
        &.success { color: #67c23a; }
        &.warning { background: #fdf6ec; color: #e6a23c; }
        &.danger { background: #fef0f0; color: #f56c6c; }
        &.info { background: #f4f4f5; color: #909399; }
        &.primary { color: #409eff; }
        i { font-size: 20px; }
      }
      .card-title { font-size: 14px; color: #606266; font-weight: 500; }
    }
    .card-content {
      .card-value {
        font-size: 28px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 8px;
        line-height: 1;
      }
      .card-trend {
        display: flex;
        align-items: center;
        font-size: 12px;
        font-weight: 500;
        i { margin-right: 4px; font-size: 12px; }
        &.trend-up { color: #67c23a; }
        &.trend-down { color: #f56c6c; }
      }
    }
  }
}
</style>
